import Splide from '@splidejs/splide';

export default {
  init() {
  
  
const mobileMenuBox = document.querySelector('.mobileMenuBox');
const mobileMenuClose = document.querySelector('.mobileMenuBox__close');
const mobileMenuOverlay = document.querySelector('.mobileMenuBox__overlay');
const hamburgerBtn = document.querySelector('.hamburger');

if (mobileMenuBox && hamburgerBtn) {
  const setMenuState = (open) => {
    hamburgerBtn.classList.toggle('is-active', open);
    mobileMenuBox.classList.toggle('is-open', open);
    mobileMenuBox.setAttribute('aria-hidden', open ? 'false' : 'true');
    hamburgerBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  hamburgerBtn.addEventListener('click', function() {
    const willOpen = !mobileMenuBox.classList.contains('is-open');
    setMenuState(willOpen);
  });
  [mobileMenuClose, mobileMenuOverlay].forEach(el => {
    if (el) el.addEventListener('click', () => setMenuState(false));
  });

  const isMobile = () => window.matchMedia('(max-width: 1024px)').matches;
  const submenuLinks = mobileMenuBox.querySelectorAll('.mobileMenu li.menu-item-has-children > a');
  submenuLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      if (!isMobile()) return; // desktop: let it navigate
      const li = link.parentElement;
      const opened = li.classList.contains('is-open');
      if (!opened) {
        e.preventDefault();
        // close siblings for cleaner UX
        const siblings = Array.from(li.parentElement.children).filter(x => x !== li);
        siblings.forEach(s => s.classList.remove('is-open'));
        li.classList.add('is-open');
      }
      // if opened, second click proceeds with navigation
    });
  });
}
// Obsługa rozwijania linków w mega menu
const menuColumns = document.querySelectorAll('.megaMenu__column');

menuColumns.forEach(column => {
  const header = column.querySelector('.megaMenu__column-header');
  const links = column.querySelector('.megaMenu__column-links');

  if (header && links) {
    header.addEventListener('click', () => {
      const isOpen = column.classList.contains('is-open');

      // zamknij wszystkie inne kolumny
      menuColumns.forEach(c => c.classList.remove('is-open'));

      // otwórz klikniętą (chyba że była już otwarta – wtedy się zamknie)
      if (!isOpen) {
        column.classList.add('is-open');
      }
    });
  }
});


const SiteNavbar = document.querySelector('.header')
  function stickyNavbar() {
      
      
      
    if (!SiteNavbar) return;
    window.scrollY > 0 ? SiteNavbar.classList.add('stickyNavbar') : SiteNavbar.classList.remove('stickyNavbar')
      
    }



    window.addEventListener('scroll', () => {
      stickyNavbar()
    })

  const el = document.querySelector('#opinie-splide');
  if (el) {
    new Splide(el, {
      type: 'loop',
      perPage: 1,
      focus: 'center',
      arrows: false,
      width: '1300px',
      pagination: true,
      autoplay: true,
      interval: 8000,
    }).mount();
  }

  // FAQ accordion
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    if (question) {
      question.addEventListener('click', () => {
        // Zamknij wszystkie inne FAQ
        faqItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
          }
        });
        
        // Toggle aktualnego
        item.classList.toggle('active');
      });
    }
  });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js